import { Contact, ContactType } from './contact';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Resource } from '@patterns/core';

@Resource('suppliers')
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class Supplier extends Contact {
  constructor(data: any = {}) {
    super(data);
    this.type = ContactType.SUPPLIER;
  }
}

